import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  pollSelector,
  pollResponsesSelector,
  respondToPollChoice,
} from '../../../reducers';
import Poll from './component';

const mapStateToProps = (state, props) => {
  const poll = pollSelector(state, props.id) || {};
  const responses = pollResponsesSelector(state, props.id) || {};
  const {type, options} = poll;
  return {
    type,
    options,
    responses,
  };
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    respond: respondToPollChoice,
  }, dispatch);
};

export const connectWrapper = connect(mapStateToProps, mapDispatchToProps);
export default connectWrapper(Poll);



// WEBPACK FOOTER //
// ./src/component/molecules/Poll/index.js